// extracted by mini-css-extract-plugin
export var logoWrapper = "hy_BQ";